import React from 'react';

export default function DisclaimerModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-sm">
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-xl w-full border border-slate-100 p-6 sm:p-8 animate-fade-in max-h-[85vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-slate-400 hover:text-slate-700 text-2xl font-semibold focus:outline-none"
          aria-label="Close modal"
        >
          &times;
        </button>

        <h2 className="text-xl font-bold text-slate-900 mb-4">AI Disclaimer</h2>
        <div className="text-slate-600 text-sm leading-relaxed space-y-4">
          <p>
            Candor includes artificial intelligence features such as code generation, ETL automation, and workflow suggestions. These features are designed to assist users, not replace human expertise. All outputs are automatically generated based on user input and may contain errors or incomplete logic. Users must review, test, and validate all AI-generated results before using them.
          </p>
          <p>
            AI-generated content is provided "as is", without any guarantees of accuracy, reliability, or suitability for production use. Candor is not responsible for any loss, damage, or issues resulting from the use or misuse of AI-generated outputs.
          </p>
          <p>
            Because AI features are powered by Large Language Models (LLMs) that operate on cloud-based infrastructure, any information entered into AI prompts may be processed by third-party systems. Proden Technologies, Inc. cannot guarantee the confidentiality or security of this information. Users should avoid entering confidential, personal, financial, or sensitive data into AI prompts and are solely responsible for ensuring that the data shared is appropriate for AI processing.
          </p>
          <p>
            Some AI features may use third-party providers such as AWS Bedrock, Groq, Anthropic, or Gemini. Candor is not responsible for their reliability, data handling, or security practices.
          </p>
          <p>
            By using AI features, users agree to use them responsibly, verify all results, and comply with applicable data protection and ethical guidelines.
          </p>
        </div>
        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="py-2 px-5 rounded-lg text-sm font-semibold text-white bg-slate-900 hover:bg-slate-800 transition-colors"
          >
            I Understand
          </button>
        </div>
      </div>
    </div>
  );
}
